import { SidebarNavContent } from './SidebarNav';

interface SidebarProps {
  isAdmin?: boolean;
}

export function Sidebar({ isAdmin = false }: SidebarProps) {
  return (
    <aside className="fixed left-0 top-14 z-30 hidden h-[calc(100vh-3.5rem)] w-56 border-r bg-background md:block">
      <SidebarNavContent isAdmin={isAdmin} className="p-4" />
    </aside>
  );
}
